import React from 'react';
import Link from '@v2/shared/components/Link';
import { useUser } from '@v2/shared/lib/user';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

/**
 * The pair of account links a header carries, and the pipe between them.
 *
 * The `info-links` block of MagSpot's and MagZoom's `layouts/full/header.html`, which is
 * the same block on both. TopMags draws the same two links as chips with its cart button
 * beside them, so it keeps its own `AccountItems`; this is the plain pair.
 *
 * The legacy header opens Log In and Sign Up in a fancybox. There is no fancybox in the
 * V2 tree, so both are plain links to the same `customer.php` pages the modal loaded —
 * which is where every brand's account links still point. Relative, so they go through
 * `buildUrl`.
 */
export default function AccountLinks() {
  const { user } = useUser();
  const { buildUrl } = useUrlGenerator();

  const className = 'text-sm text-slate-700 no-underline hover:text-primary';

  return (
    <span className="whitespace-nowrap">
      {user ? (
        <>
          <Link href={buildUrl('/customer?xCmd=account')} className={className}>
            My Account
          </Link>
          <span className="px-1.5 text-slate-400">|</span>
          <Link href={buildUrl('/customer?xCmd=logout')} className={className}>
            Logout
          </Link>
        </>
      ) : (
        <>
          <Link href={buildUrl('/customer?xCmd=login')} className={className}>
            Log In
          </Link>
          <span className="px-1.5 text-slate-400">|</span>
          <Link href={buildUrl('/customer?xCmd=register&xFwd=')} className={className}>
            Sign Up
          </Link>
        </>
      )}
    </span>
  );
}
